module.exports = __webpack_public_path__ + "img/facebook.e440542a.svg";